import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, getDocs, deleteDoc, doc, query, orderBy } from 'firebase/firestore';
import { db } from '../../config/firebase';
import FileViewer from '../../components/common/FileViewer';

function AutomationManagement() {
  const [automations, setAutomations] = useState([]);
  const [loading, setLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchAutomations();
  }, []);

  const fetchAutomations = async () => {
    setLoading(true);
    try {
      const q = query(collection(db, 'automations'), orderBy('createdAt', 'desc'));
      const querySnapshot = await getDocs(q);
      const automationsList = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setAutomations(automationsList);
    } catch (error) {
      setError('Otomasyonlar yüklenirken bir hata oluştu');
      console.error('Otomasyonlar yüklenirken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (automationId) => {
    if (window.confirm('Bu otomasyonu silmek istediğinizden emin misiniz?')) {
      try {
        await deleteDoc(doc(db, 'automations', automationId));
        await fetchAutomations(); // Listeyi yenile
      } catch (err) {
        alert('Otomasyon silinirken bir hata oluştu');
        console.error(err);
      }
    }
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Otomasyon Yönetimi</h2>
        <Link
          to="/admin/automations/new"
          className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700"
        >
          Yeni Otomasyon
        </Link>
      </div>

      {loading ? (
        <div>Yükleniyor...</div>
      ) : (
        <div className="grid gap-6">
          {automations.map(automation => (
            <div key={automation.id} className="bg-white p-6 rounded-lg shadow">
              <h3 className="text-xl font-semibold mb-2">{automation.title}</h3>
              <p className="text-gray-600 mb-2">{automation.description}</p>
              <p className="text-sm text-gray-500 mb-4">
                Kategori: {automation.category}
              </p>
              
              {/* Dosyaları Görüntüle */}
              {automation.files && automation.files.length > 0 && (
                <div className="mt-4">
                  <h4 className="text-sm font-medium text-gray-700 mb-2">Dosyalar:</h4>
                  <div className="space-y-2">
                    {automation.files.map((file, index) => (
                      <div key={index} className="flex items-center space-x-4">
                        <FileViewer file={file} />
                        {file.type.startsWith('image/') && (
                          <img 
                            src={file.data} 
                            alt={file.name}
                            className="h-20 w-20 object-cover rounded"
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="mt-4 flex justify-end space-x-4">
                <Link
                  to={`/admin/automations/edit/${automation.id}`}
                  className="text-blue-600 hover:text-blue-800"
                >
                  Düzenle
                </Link>
                <button
                  onClick={() => handleDelete(automation.id)}
                  className="text-red-600 hover:text-red-800"
                >
                  Sil
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default AutomationManagement; 